import tinycolor from "tinycolor2";
const textColor = {
  color_gray_50: "rgb(15, 15, 16)",
  color_gray_100: "rgba(40, 41, 42, 0.65)",
  color_gray_200: "rgba(42, 43, 45, 0.8)",
  color_gray_300: "rgba(58, 58, 60, 0.8)",
  color_gray_400: "rgba(90, 91, 93, 0.8)",
  color_gray_500: "rgba(139, 140, 143, 0.8)",
  color_gray_600: "rgba(195, 196, 199, 0.8)",
  color_gray_700: "rgba(227, 228, 231, 0.8)",
  color_gray_800: "rgba(231, 232, 234, 0.85)",
  color_gray_900: "rgba(238, 238, 240, 0.9)",
  color_gray_950: "rgba(235, 235, 236, 0.95)",
};

function getTextColor(backgroundColor: string): string {
  const color = tinycolor(backgroundColor);
  return tinycolor.mostReadable(color, Object.values(textColor)).toHexString();
}

export const ColorUtils = {
  getTextColor,
};
